import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1800&q=80";

export const About = () => {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="eyebrow mb-6" data-testid="about-eyebrow">
            {t.about.eyebrow}
          </div>
          <h2
            data-testid="about-title"
            className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light text-[#F8F8F8] leading-[1.05] tracking-tight"
          >
            {t.about.title}
          </h2>
          <div className="mt-10 space-y-6 text-[#A1A1AA] text-base md:text-lg leading-relaxed font-light max-w-xl">
            <p data-testid="about-body-1">{t.about.body_1}</p>
            <p data-testid="about-body-2">{t.about.body_2}</p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-px bg-white/5">
            {t.about.pillars.map((p, i) => (
              <div
                key={i}
                data-testid={`pillar-${i}`}
                className="bg-[#0A0A0A] p-6"
              >
                <div className="text-[#D4AF37] font-serif-display text-xl mb-2">
                  {p.title}
                </div>
                <div className="text-sm text-[#A1A1AA] leading-relaxed">
                  {p.body}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Aerial Dubai cityscape"
              className="w-full h-[420px] md:h-[560px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
            <div className="absolute bottom-6 start-6 end-6 flex items-center justify-between text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">
              <span>Dubai · UAE</span>
              <span className="text-[#D4AF37]">Est. Brokers Lounge</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
